import React, { useState, useEffect } from 'react';
//imports core
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import useAuth from "hooks/useAuth";
import api from "assets/services/api.js";
import ModalDeleteOrder from "components/ModalDeleteOrder/ModalDeleteOrder";
import ModalUpdateOrder from 'components/ModalUpdateOrder/ModalUpdateOrder';
import ModalUpdateOrderHeader from 'components/ModalUpdateOrderHeader/ModalUpdateOrderHeader';
import ModalAddProductOrder from 'components/ModalAddProductOrder/ModalAddProductOrder';
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate, formatDateWithHours } from "services/formatDate.js";
//imports Material
import { Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Button from '@mui/material/Button';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.80)",
            margin: "0",
            fontSize: "1.2em",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "200",
        fontSize: "1.4em",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "0px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "60%",
            fontWeight: "300",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    marginlt: {
        marginTop: '0px',
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px"
    },
    bigcheckbox: {
        width: "30px",
        height: "30px"
    },
    cardCenter: {
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
    },
    marginLeft: {
        marginLeft: '30px'
    }

};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableOrder({ order, style, indexOfOrder, loadOrders, toogle, handleChecked, handleCheckedAll, toogleCancel }) {
    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId, garlicType } = useAuth();
    const head = {
        invoice: ["Produto", "Quantidade", "Quantidade em Caixas", "Pagamento", "Natureza da operação", "Valor unitário", "Desconto", "Lote", "Data do pedido", "Data de entrega", "Vendedor", "Observação"],
        not_invoice: ["Selecionar", "Produto", "Quantidade", "Quantidade em Caixas", "Pagamento", "Natureza da operação", "Valor unitário", "Desconto", "Data do pedido", "Data de entrega", "Vendedor", "Observação", "Ações"]
    };
    const nature_operation = {
        sell: "Venda",
        sample: "Amostra",
        bonification: "Bonificação",
        return: "Devolução"
    };
    const control_cehck_table = toogle || toogleCancel ? false : true;

    const [index, setIndex] = useState(order ? order : { id: 1 });
    const [allOrdersChecked, setAllOrdersChecked] = useState(false);
    const [indeterminate, setInterminate] = useState(false);

    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowUpdateHeader, setModalShowUpdateHeader] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
    const [importModal, setImportModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        controlIntermitente();
    }, [order])

    const loadModal = async () => {
        setImportModal(true);
    }

    function callModalUpdateHeader(index) {
        if (!modalShowUpdateHeader) {
            loadModal();
        }
        setIndex(index);
        setModalShowUpdateHeader(true);
    }

    function callModalUpdate(index) {
        if (!modalShowUpdate) {
            loadModal();
        }
        setIndex(index);
        setModalShowUpdate(true);
    }

    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        }
        setIndex(index);
        setModalShowDelete(true)
    }

    function callModalAddProduct(index) {
        if (!modalShowAddProduct) {
            loadModal();
        }
        setIndex(index);
        setModalShowAddProduct(true)
    }

    async function generateOrderStatement(order_controller, client) {
        setLoading(true);
        const response = await api.post('/sell/generate/statement/pdf', {
            id: storageId,
            data: [{ "order_controller": order_controller }],
            type: "order",
            userType: "admin"
        }, {
            responseType: "blob", // Definido aqui
        }).then(async function (response) {
            let blob = new Blob([response.data], {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Pedido_${client} - ${order_controller}.pdf`;
            link.click();
        }).catch(function (error) {
            console.log(error);
        });
        setLoading(false);
    };

    function getNf() {
        let teste = [];
        order.products.map((prod, i) => {
            teste[i] = [];
            if (control_cehck_table) {
                teste[i].push(
                    <FormControlLabel
                        key={prod.id}
                        control={
                            <Checkbox
                                className={classes.checkbox}
                                checked={prod.checked}
                                onChange={() => controlCheck(i, prod.id)}
                            />
                        }
                    />
                );
            }
            teste[i].push(prod.name);
            teste[i].push(prod.amount)
            teste[i].push(Number.isInteger(prod.amount / prod.box) ? (prod.amount / prod.box) : parseFloat(prod.amount / prod.box).toFixed(3));
            teste[i].push(order.payment);
            teste[i].push(nature_operation[order.nature]);
            teste[i].push(`R$ ${prod.price}`);
            teste[i].push(`R$ ${prod.discount}`);
            if (toogle) {
                teste[i].push(order.batch);
            }
            teste[i].push(formatDateWithHours(order.created_at));
            teste[i].push(formatDate(order.date_of_delivery));
            teste[i].push(order.sellsman_name);
            teste[i].push(order.observation);
            if (control_cehck_table) {
                teste[i].push(
                    <div className={classes2.tableActions}>
                        <Tooltip
                            id="tooltip-top-start"
                            title="Deletar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Close"
                                className={classes2.tableActionButton}
                                onClick={() => callModalDelete(prod)}
                            >
                                <Close
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.close
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip
                            id="tooltip-top"
                            title="Editar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalUpdate(prod)}

                            >
                                <Edit
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit
                                    }
                                />
                            </IconButton>

                        </Tooltip>
                    </div>
                )
            }
        });

        return teste;
    };

    const controlCheck = (i, id) => {
        handleChecked(indexOfOrder, i, id);
        controlIntermitente();
    };

    const controlCheckAll = (totalProd) => {
        handleCheckedAll(indexOfOrder);
        controlIntermitente();
    };

    const controlIntermitente = () => {
        let amountOrder = 0;
        order.products.forEach(element => {
            if (element.checked) {
                amountOrder += 1;
            }
        });
        if (amountOrder === order.products.length) {
            setAllOrdersChecked(true);
        } else if (amountOrder > 0 && amountOrder < order.products.length) {
            setInterminate(true);
        } else {
            setAllOrdersChecked(false);
            setInterminate(false);
        }
    }

    return (
        <GridItem style={style} xs={12} sm={12} md={12} >
            <div className={classes.marginlt}>
                <FormGroup>
                    {order !== undefined ? (
                        <GridItem xs={12} sm={12} md={12}>
                            <Card className={classes.test}>
                                <CardHeader className={classes.zindex} color={(order.cancelled ? "warning" : (order.invoice ? "success" : "danger"))}>
                                    <div style={{ display: 'flex' }}>
                                        {control_cehck_table ?
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={allOrdersChecked}
                                                        indeterminate={indeterminate}
                                                        onChange={() => { controlCheckAll(order) }}
                                                    />
                                                }
                                            /> : ""}
                                        <h4 className={classes.cardTitleWhite}>
                                            {order.client.social_reason} - <Button variant="outlined"
                                                onClick={() => { generateOrderStatement(order.order_controller, order.client.social_reason) }}
                                                style={{
                                                    borderColor: 'white',
                                                    borderWidth: '3px',
                                                    color: 'white',
                                                    fontSize: '17px'
                                                }}>
                                                {order.order_controller}
                                            </Button>
                                            <div className={classes.floatRight}>
                                                <Tooltip
                                                    id="tooltip-top"
                                                    title="Editar"
                                                    placement="top"
                                                    classes={{ tooltip: classes2.tooltip }}
                                                    className={classes.marginLeft}
                                                >
                                                    <IconButton
                                                        aria-label="Edit"
                                                        className={classes2.tableActionButton}
                                                        onClick={() => callModalUpdateHeader(order)}
                                                    >
                                                        <Edit
                                                            className={
                                                                classes2.tableActionButton + " " + classes2.edit2
                                                            }
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>


                                        </h4>
                                    </div>
                                    <p className={classes.cardCategoryWhite}>{order.client.address}</p>

                                </CardHeader>
                                <CardBody className={classes.ftsize}>
                                    <Table
                                        tableHeaderColor="danger"
                                        tableHead={toogle ? head.invoice : head.not_invoice}
                                        tableData={getNf()}>
                                    </Table>
                                    {control_cehck_table ?
                                        <div className={classes.cardCenter}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Adicionar produto"
                                                placement="top"
                                                classes={{ tooltip: classes2.tooltip }}
                                            >
                                                <IconButton
                                                    aria-label="Edit"
                                                    className={classes2.buttonIcon}
                                                    onClick={() => callModalAddProduct(order)}

                                                >
                                                    <AddCircleOutlineIcon
                                                        sx={{ fontSize: 40 }}
                                                        className={
                                                            classes2.sizeAddContact + " " + classes2.addContacts
                                                        }
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </div> : ""}
                                </CardBody>
                            </Card>
                        </GridItem >
                    ) : <div></div>}
                </FormGroup>
            </div>
            {importModal && modalShowDelete && (<ModalDeleteOrder key={String("del_" + index.id)} props={index} loadOrders={loadOrders()} show={modalShowDelete}
                onHide={() => setModalShowDelete(false)} />
            )}
            {importModal && modalShowUpdate && (
                <ModalUpdateOrder key={String("upd_" + index.id)} props={index} loadOrders={loadOrders()} show={modalShowUpdate}
                    onHide={() => setModalShowUpdate(false)} />
            )}
            {importModal && modalShowUpdateHeader && (
                <ModalUpdateOrderHeader key={String("upd_" + index.id)} props={index} loadOrders={loadOrders()} show={modalShowUpdateHeader}
                    onHide={() => setModalShowUpdateHeader(false)} />
            )}
            {importModal && modalShowAddProduct && (
                <ModalAddProductOrder key={String("upd_" + index.id)} props={index} loadOrders={loadOrders()} show={modalShowAddProduct}
                    onHide={() => setModalShowAddProduct(false)} />
            )}
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </GridItem>
    );
}

export default TableOrder;